/**
 * Distances Widget — accordion via <details>/<summary>
 * ====================================================
 * Only the title + km are visible on load; clicking an item slides the
 * remaining info (doelgroep, kosten, omschrijving, inschrijflink) open.
 *
 * Mirrors the approach used in elementor/widgets/faq.js: the panel height is
 * interpolated from/to its scrollHeight so it grows and shrinks smoothly
 * instead of jumping.
 */

// Duration of the open/close animation in milliseconds
const DURATION = 300;

/**
 * Animate a single <details> element open or closed.
 *
 * @param {HTMLDetailsElement} details
 * @param {boolean} open - true = opening, false = closing
 */
function animateDetails( details, open ) {
    const panel = details.querySelector( '.distances-widget__panel' );

    if ( ! panel ) {
        return;
    }

    // Cancel any animation that is already running on this element
    if ( details._animation ) {
        details._animation.cancel();
    }

    // When opening we need the element in the DOM first so we can read its height
    if ( open ) {
        details.open = true;
    }

    const fullHeight = panel.scrollHeight + 'px';

    details._animation = panel.animate(
        [
            { height: open ? '0px' : fullHeight, opacity: open ? 0 : 1 },
            { height: open ? fullHeight : '0px', opacity: open ? 1 : 0 },
        ],
        { duration: DURATION, easing: 'ease' }
    );

    details._animation.onfinish = () => {
        details._animation = null;
        panel.style.height = '';

        // Remove the open attribute after the close animation finishes
        if ( ! open ) {
            details.open = false;
        }
    };
}

/**
 * Attach click handlers to every <details> inside a distances widget.
 *
 * @param {HTMLElement} list
 */
function initDistancesWidget( list ) {
    list.querySelectorAll( '.distances-widget__details' ).forEach( ( details ) => {
        const summary = details.querySelector( 'summary' );

        // Items without extra info stay open and are not interactive
        if ( ! summary || details.classList.contains( 'distances-widget__details--static' ) ) {
            return;
        }

        // The whole card is clickable. Clicks on the summary (incl. keyboard
        // Enter/Space, which fire a click) bubble up to the item as well.
        const item = details.closest( '.distances-widget__item' ) || summary;

        item.addEventListener( 'click', ( e ) => {
            // Let links / buttons (e.g. the register button) do their own thing
            if ( e.target.closest( 'a, button' ) ) {
                return;
            }

            // Don't toggle when the user is selecting text
            const selection = window.getSelection();
            if ( selection && ! selection.isCollapsed && item.contains( selection.anchorNode ) && ! e.target.closest( 'summary' ) ) {
                return;
            }

            // Prevent the browser's native toggle so we control it ourselves
            e.preventDefault();

            animateDetails( details, ! details.open );
        } );
    } );
}

// In the Elementor editor, open all items so the editor can see and edit them
if ( document.body.classList.contains( 'elementor-editor-active' ) ) {
    document.querySelectorAll( '.distances-widget__details' ).forEach( ( details ) => {
        details.open = true;
    } );
} else {
    document.querySelectorAll( '[data-distances-accordion]' ).forEach( initDistancesWidget );
}

